<template>

  <div data-v-3012959e="" class="appliance-table-list_item" data-v-7ba5bd90="">
    <div data-v-3012959e="" class="el-row" data-v-7ba5bd90="" style="margin-left: -10px; margin-right: -10px;">
      <div data-v-3012959e="" class="name el-col el-col-8" data-v-7ba5bd90=""
        style="padding-left: 10px; padding-right: 10px; text-align: left; vertical-align: text-top; font-family:Rajdhani;">
        <img v-if="pObj.selected"        data-v-3012959e="" :src="require('../assets/'+pObj.activeImg)"  alt="" data-v-7ba5bd90="">
        <img v-else  data-v-3012959e="" :src="require('../assets/'+pObj.img)"  alt="" data-v-7ba5bd90=""> 
        {{pObj.title}}
      </div>
      <div data-v-3012959e="" class="el-col el-col-3" data-v-7ba5bd90="" style="padding-left: 10px; padding-right: 10px;">
        <label data-v-3012959e="" class="el-checkbox cal-checkbox" data-v-7ba5bd90=""></label>
      </div>
      <div data-v-3012959e="" class="el-col el-col-4" data-v-7ba5bd90="" style="padding-left: 10px; padding-right: 10px;">
        <el-switch  v-model="pObj.selected"  active-color="#13ce66"  inactive-color="#f2f2f2" @click="change"></el-switch>
      </div>
      <div data-v-3012959e="" class="el-col el-col-6" data-v-7ba5bd90="" style="padding-left: 10px; padding-right: 10px;">
        <el-input-number v-model="pObj.quantity" :min="1" :max="10"></el-input-number>
      </div>
      <div data-v-3012959e="" class="edit-icon el-col el-col-3" data-v-7ba5bd90=""
        style="padding-left: 10px; padding-right: 10px;"><img data-v-3012959e="" :src="require('../assets/arrow-down-solid.svg')"
          alt="" class="" data-v-7ba5bd90="" @click="change"></div>
    </div><!---->


    <el-dialog v-model="pObj.openpopup" label-position="left" :before-close="close" draggable top="20%">
      <el-form :rules="rules2" ref="formModel2">
        <el-form-item style="font-family:Rajdhani" label="Backup Duration" :label-width="auto" :rules="[ { required: true, message: 'Please input ', trigger: 'blur' } ]">
          <el-input v-model="pObj.backup_Duration"  type="number"  autocomplete="off"></el-input>
        </el-form-item>


        <el-form-item style="font-family:Rajdhani" v-if="pObj.popupdropdown" label="Nominal Power&nbsp;&nbsp;" :label-width="auto" :rules="[ { required: true, message: 'Please input ', trigger: 'blur' } ]">
          <el-select v-model="pObj.nominal_Power" placeholder="Please select" style="width:95%">
            <el-option
              v-for="item in pObj.popupdropdown"
              :key="item.keyvalue"
              :label="item.keyname"
              :value="item.keyvalue">
            </el-option>
          </el-select>
          <label style="width:5%">{{pObj.unit}}</label>
        </el-form-item>

        <el-form-item style="font-family:Rajdhani" v-else label="Nominal Power&nbsp;&nbsp;" :label-width="auto" :rules="[ { required: true, message: 'Please input ', trigger: 'blur' } ]">
          <el-input v-model="pObj.nominal_Power"  type="number"  autocomplete="off"></el-input>
        </el-form-item>
        
        
      </el-form>
      <div class="dialog-footer">
        <el-button type="primary" style="font-family:Rajdhani" @click="submitForm();close();">Confirm</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>

import { ref } from 'vue';
import { toRefs } from "@vue/reactivity";

export default {

  props: ["name"],
  setup(props, context) {
    console.log("props===", props);
    console.log("context===", context);
    let topHight=0;
    const pObj = toRefs(props).name;

    console.log("pObj====", pObj);
    console.log(pObj.value.age);
    const change = (event) => {
      // pObj.value.id++
      console.log("pObj",pObj)
      if(pObj.value.selected){
        console.log("change---"+event.clientX + "  "+ event.clientY)
        topHight = event.clientY+'px'
        console.log("topHight---"+topHight)
        pObj.value.openpopup = true
      }else{
        pObj.value.openpopup = false
      }
      
    }
    const close = () => {
      // pObj.value.id++
      console.log(1111)
      pObj.value.openpopup = false
    }
    const submitForm = ()=>{
      
      const formRef = formModel2.value;
      formRef.validate((valid) => {
        if (valid) {
          pObj.value.openpopup = false
        } else {
          console.log('Form is invalid. Please check the fields.');
        }
      });
      
    }

    const formModel2 = ref({
      backup_Duration: '',
      nominal_Power: ''
    });

    const rules2 = ref({
      backup_Duration: [{ required: true, message: 'Please enter your duration', trigger: 'change' }],
      nominal_Power: [{ required: true, message: 'Please enter your nominal_Power', trigger: 'change' }],
    });

    return {
      pObj,
      change,
      close,
      submitForm,
      formModel2,
      rules2,
      topHight
    };
  }
};
</script>
